import React from 'react'
import axios from 'axios'
import moment from 'moment/moment'
import { useQuery } from 'react-query'

const ImportModels = () => {

  const {
    data: ElementJSON,
  } = useQuery('/api/migration/element_json',
    async () => {
      const { data } = await axios.get('/api/migration/element_json')
      return data
    },
    {
      retry: false,
    },
  )

  const download = async () => {
    try {
      const { data: url } = await axios.get(
        '/api/migration/presigned_download_json')
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', ElementJSON.Name)
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      if (error.response) {
        console.log(error.response.data)
        console.log(error.response.status)
        console.log(error.response.headers)
      } else if (error.request) {
        console.log(error.request)
      } else {
        console.log('Error', error.message)
      }
      console.log(error.config)
    }
  }

  return (
    <div className={'row'}>
      <div className={'col-3'}>
        <div>
          <button
            className={'btn btn-secondary btn-block p-1 btn-theme mt-2 mb-0'}
            onClick={download}
            disabled={!ElementJSON}
          >Download Knackly Elements
          </button>
          {ElementJSON && <small>Elements last updated: {
            moment(ElementJSON.LastModified).format('L LTS')
          }</small>}
        </div>
      </div>
      <div className={'col-9'}>Notes/documentation?</div>
    </div>
  )
}

export default ImportModels
